
export const grid = (element) => {
    let postTitle = element.post_title;
    if( element.blogExtra.length ) {
        if(element.blogExtra.blog_post_title != '') {
            postTitle = element.blogExtra.blog_post_title
        }
    }
    
    return `
    <div class="archive-card-grid col-md-4 col-lg-4 col-sm-12" data-posturl="${element.pageLink}">
        <div class="image-wrapper">
            <img src="${element.img}" alt="${postTitle}" />
        </div>
        <div class="content">
            ${element.date ? `<p class="fw-bold">${element.date}</p>` : ''}
            <p class="fw-bold">${postTitle}</p>
            <a class="fw-bold link-know-more link" href="${element.pageLink}">${element.readMore}</a>
        </div>
    </div>
    `
}

export const list = (element, featured = false) => {
    let postTitle = element.post_title;
    if( element.blogExtra ) {
        if(element.blogExtra.blog_post_title != '') {
            postTitle = element.blogExtra.blog_post_title
        }
    }
    return `
    <div class="archive-card-list ${featured ? "feature" : ""} col-md-12 col-lg-12 col-sm-12" data-posturl="${element.pageLink}">
        <div class="row">
            <div class="col-md-4 col-lg-4">
                <div class="content">
                    ${element.date ? `<p class="date">${element.date}</p>` : ''}
                    <p class="fw-bold">${element.post_title}</p>
                    <a class="fw-bold link-know-more link" href="${element.pageLink}">${element.readMore}</a>
                </div>
            </div>
            <div class="col-md-8 col-lg-8">
                <div class="image-wrapper">
                    <img class="" src="${element.img}" alt="${element.post_title}}">
                </div>
            </div>
        </div>
    </div>
    `
}